import { render, staticRenderFns } from "./ImageDropzone.vue?vue&type=template&id=6f361fd2&"
import script from "./ImageDropzone.vue?vue&type=script&lang=js&"
export * from "./ImageDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports